export enum PartnersList {
  BCV = 'bcv'
}
